import React from 'react'

const NotFound = () => {
    return (
        <div>
           <h1> Not found</h1> 
           <p className="lead">The page you looking for is not found...</p>
        </div>
    )
}

export default NotFound
